export default "__VITE_ASSET__BNbxSUQj__ 300w, __VITE_ASSET__BzRp8CJF__ 563w";